import currencyInput from './currencyInput';
import pullToRefresh from './pullToRefresh';
import focusPositionEnd from './focusPositionEnd';
import onLongPress from './onLongPress';

let directivesModule = angular

  .module('common.directives', [])

  .directive('currencyInput', ['$filter', currencyInput])

  .directive('pullToRefresh', ['$q', '$translate', '$timeout', pullToRefresh])

  .directive('focusPositionEnd', ['$timeout', focusPositionEnd])

  .directive('onLongPress', ['$timeout', onLongPress])

  .name;

export default directivesModule;



// WEBPACK FOOTER //
// ./client/app/common/directives/directives.js